module.exports = {
      id: "chevron-usage",
      viewBox: "0 0 13.4 5",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }